let params = {};
window.location.search
  .substr(1)
  .split('&')
  .forEach((elm) => {
    if (elm === '') return;
    const spl = elm.split('=');
    const d = decodeURIComponent;
    params[d(spl[0])] = spl.length >= 2 ? d(spl[1]) : true;
  });

export default params;
